
import axios from 'axios';



const API_BASE_URL = process.env.REACT_APP_API_URL || '/api';



const api = axios.create({

  baseURL: API_BASE_URL

});



api.interceptors.request.use(config => {

  const token = localStorage.getItem('token');

  if (token) config.headers.Authorization = `Bearer ${token}`;

  return config;

});



api.interceptors.response.use(

  response => response,

  error => {

    const status = error.response?.status;

    const url = error.config?.url || '';

    if (status === 401 && !url.endsWith('/auth/login') && !url.endsWith('/auth/register')) {

      localStorage.removeItem('token');

      // El módulo de salas de juntas tiene su propio login bajo /salas.
      window.location.href = window.location.pathname.startsWith('/salas') ? '/salas/login' : '/login';

    }

    // 429 (rate limit): reintentar solo GETs (idempotentes), máx 2 veces,
    // respetando Retry-After del servidor. Sin esto la vista se queda
    // "pasmada" esperando datos que nunca llegan.
    const config = error.config;

    if (status === 429 && config && (config.method || 'get').toLowerCase() === 'get') {

      config._retry429 = (config._retry429 || 0) + 1;

      if (config._retry429 <= 2) {

        const retryAfter = Number(error.response?.headers?.['retry-after']);

        const waitMs = Number.isFinite(retryAfter) && retryAfter > 0
          ? Math.min(retryAfter * 1000, 15000)
          : 1500 * config._retry429;

        return new Promise(resolve => setTimeout(resolve, waitMs)).then(() => api(config));

      }

    }

    return Promise.reject(error);

  }

);



export default api;

